import createPersistedState from "vuex-persistedstate";
import hfox from "./hfox";
import schedules from "./schedules";

import { FusionProject } from "@/types";

const namespace: FusionProject = "hfox";

export const plugins = [
  createPersistedState({
    key: namespace,
    paths: [
      namespace + ".balance",
      namespace + ".etfs",
      namespace + ".plans",
      namespace + ".schedules.entered",
      namespace + ".schedules.hideAutoSchedule",
      namespace + ".schedules.drafts"
    ]
  })
];

export default {
  ...hfox,
  modules: {
    schedules
  }
};
